import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "devices-page" }
const _hoisted_2 = { class: "user-devices" }
const _hoisted_3 = { class: "devices-inner-container" }
const _hoisted_4 = { class: "devices d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-0" }, "Manage Devices", -1)
const _hoisted_6 = {
  key: 0,
  class: "devices-helper mt-2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, " Here are the devices currently signed in to your account. ", -1)
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = {
  key: 1,
  class: "mt-3 text-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "alert-danger mt-3 text-danger"
}
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "device-card-row" }
const _hoisted_15 = { class: "device-icon" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "device-info" }
const _hoisted_18 = { class: "mb-1" }
const _hoisted_19 = { class: "mb-0 text-muted" }
const _hoisted_20 = { class: "mb-0" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", null, "Last login:", -1)
const _hoisted_22 = { class: "device-right" }
const _hoisted_23 = {
  key: 0,
  class: "current-device-badge"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 4,
  class: "mt-4"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 fw-semibold" }, " No devices are currently registered. ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, " This feature becomes available after you sign out and sign in again. Your current session was created before device tracking was enabled. ", -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_32 = {
  key: 5,
  class: "d-flex justify-content-center mt-4"
}
const _hoisted_33 = {
  key: 6,
  class: "d-flex justify-content-center mt-4"
}
const _hoisted_34 = {
  key: 0,
  class: "modal d-block"
}
const _hoisted_35 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_36 = { class: "modal-content" }
const _hoisted_37 = { class: "modal-header" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h4", { class: "modal-title fw-bold" }, "Remove device", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "modal-body" }
const _hoisted_42 = {
  key: 0,
  class: "mt-2 text-muted"
}
const _hoisted_43 = { class: "modal-footer" }
const _hoisted_44 = {
  key: 1,
  class: "modal d-block"
}
const _hoisted_45 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_46 = { class: "modal-content" }
const _hoisted_47 = { class: "modal-header" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("h4", { class: "modal-title fw-bold" }, "Sign out", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, "Do you want to sign out from all the devices?", -1)
const _hoisted_52 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("a", {
              class: "btn signout-popup text-white",
              role: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goLinkDevice && _ctx.goLinkDevice(...args)))
            }, "Link device")
          ]),
          (!_ctx.loading && _ctx.devices.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("p", _hoisted_8, [
                  _createTextVNode(" If something looks unfamiliar, remove it to sign it out. You can also "),
                  _createElementVNode("a", {
                    class: "devices-link",
                    role: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/change-password')))
                  }, " update your password "),
                  _createTextVNode(" for extra security. ")
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
            : _createCommentVNode("", true),
          (_ctx.error.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.devices.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, (d) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: d.deviceId,
                    class: "card w-100 mb-2"
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                          src: _ctx.getDeviceIcon(d.deviceOs),
                          alt: "device icon",
                          class: "device-icon-img"
                        }, null, 8, _hoisted_16)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.formatEnum(d.deviceOs)), 1),
                        _createElementVNode("p", _hoisted_19, _toDisplayString(d.deviceName ? d.deviceName : _ctx.formatEnum(d.deviceType)), 1),
                        _createElementVNode("p", _hoisted_20, [
                          _hoisted_21,
                          _createTextVNode(" " + _toDisplayString(_ctx.formatLastLogin(d.lastSeenAt)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        (_ctx.isCurrentDevice(d))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, "CURRENT DEVICE"))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              role: "button",
                              class: "remove-device",
                              "aria-label": "Remove device",
                              onClick: ($event: any) => (_ctx.openRemoveModal(d))
                            }, _hoisted_26, 8, _hoisted_24))
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.devices.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_30))
            : _createCommentVNode("", true),
          _hoisted_31,
          (!_ctx.loading && _ctx.devices.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.doSignOut && _ctx.doSignOut(...args))),
                  class: "btn signout-popup text-white",
                  role: "button"
                }, "Sign out")
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.devices.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("a", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSignOutModal = true)),
                  class: "btn signout-popup text-white",
                  role: "button"
                }, "Sign out from all devices")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("button", {
                  role: "button",
                  class: "close close-modal",
                  "aria-label": "Close",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeRemoveModal && _ctx.closeRemoveModal(...args)))
                }, _hoisted_40)
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createTextVNode(" Are you sure you want to remove this device? "),
                (_ctx.selectedDevice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.formatEnum(_ctx.selectedDevice.deviceOs)) + " • " + _toDisplayString(_ctx.formatEnum(_ctx.selectedDevice.deviceType)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("a", {
                  class: "btn cancel-btn",
                  role: "button",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeRemoveModal && _ctx.closeRemoveModal(...args)))
                }, "Cancel"),
                _createElementVNode("a", {
                  class: "btn signout-popup text-white",
                  role: "button",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.confirmRemove && _ctx.confirmRemove(...args)))
                }, "Yes")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSignOutModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("button", {
                  role: "button",
                  class: "close close-modal",
                  "aria-label": "Close",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showSignOutModal = false))
                }, _hoisted_50)
              ]),
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("a", {
                  class: "btn cancel-btn",
                  role: "button",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showSignOutModal = false))
                }, "Cancel"),
                _createElementVNode("a", {
                  class: "btn signout-popup text-white",
                  role: "button",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.doLogoutFromAll && _ctx.doLogoutFromAll(...args)))
                }, "Yes")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}